export const _basePath = process.env.BASE_PATH || "";
